<div
    *ngIf="type =='slider'||type =='commonSlider' ||type =='gallery'||type =='partnerLogo'||type =='formImage' || type =='image' || type =='stepGuideImage'">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutWrap="wrap" fxLayoutAlign="start">
        <div fxFlex.gt-sm="20" fxFlex.lt-md="70" fxLayout="column" class="pr-1">
            <h4>Select files</h4>
            <div class="file-type" fxFlex.lt-md="50" ng2FileDrop (fileOver)="fileOverBase($event)"
                [uploader]="uploader">Base drop zone
            </div>
            <div class="file-type" fxFlex.lt-md="50" ng2FileDrop (fileOver)="fileOverAnother($event)"
                [uploader]="uploader">
                Another drop zone
            </div>
            <button [attr.guide]="'common-file-upload-btn-1' + '__' + sanitizeUrl(url)" style="width: fit-content;"
                type="button" mat-raised-button (click)="file.click()">
                <mat-icon class="material-icons-outlined">cloud_upload</mat-icon>
                <span>Choose File</span>
            </button>
            <input [attr.guide]="'common-file-upload-inp-files' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" hidden
                #file type="file" name="files" ng2FileSelect [uploader]="uploader" [multiple]="multiple !== false" />
        </div>
        <div fxFlex.gt-sm="80" fxFlex.lt-md="100">
            <div class="pad-wrap">
                <h4 fxLayout="row">
                    <span fxFlex>Upload queue</span>
                    <span>Queue length: {{ uploader?.queue?.length }}</span>
                </h4>

                <div class="uploadTable">
                    <div class="titleHead" fxLayout="row" fxLayoutAlign="start center">
                        <div class="head" fxFlex="50">
                            <span>Filename</span>
                        </div>
                        <div class="head" fxFlex="30">
                            <span>Size</span>
                        </div>
                        <div class="head" fxFlex="20" style="text-align: center;">
                            <span>Action</span>
                        </div>
                    </div>
                    <div class="titleHead1" *ngFor="let row of uploader.queue; let i = index" fxLayout="row" fxLayoutAlign="start center">
                        <div class="head1" fxLayoutAlign="start center" fxFlex="50" style="min-width: 0; overflow: hidden;">
                            <span [title]="row?.file?.name" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block; width: 100%;">
                                {{ row?.file?.name }}
                            </span>
                        </div>
                        <div class="head1" fxLayoutAlign="start center" fxFlex="30" style="min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                            <span>{{ row?.file?.size / 1024 / 1024 | number:'.3' }} MB</span>
                        </div>
                        <div class="head1" fxLayoutAlign="center center" fxFlex="20" fxLayoutGap="4px">
                            <span *ngIf="uploadmsg=='File Uploaded Successfully..'">
                                <mat-icon>check</mat-icon>
                            </span>
                            <span *ngIf="row.isCancel">
                                <mat-icon>cancel</mat-icon>
                            </span>
                            <span *ngIf="row.isError">
                                <mat-icon>delete</mat-icon>
                            </span>
                            <button [attr.guide]="'common-file-upload-btn-3' + '__' + sanitizeUrl(url)" color="warn"
                                mat-icon-button type="button" (click)="row.remove()">
                                <mat-icon>remove_circle_outline</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="mrgn-b-md">
                    <p>Queue progress:</p>
                    <mat-progress-bar mode="determinate" value="{{uploader.progress}}">
                    </mat-progress-bar>
                </div>
                <div fxLayout="row" class="padding-10" fxLayoutGap="10px" fxLayout.lt-md="column"
                    fxLayoutAlign.gt-md="start center">
                    <button [attr.guide]="'common-file-upload-btn-4' + '__' + sanitizeUrl(url)" fxFlex.lt-md
                        [disabled]="text !='Upload all'" (click)="upload()" type="button" mat-raised-button color="primary">
                        <mat-icon>cloud_upload</mat-icon>
                        <span>{{text}}</span>
                        <mat-icon *ngIf="text !='Upload all' ">
                            <mat-spinner color="primary" diameter="20"></mat-spinner>
                        </mat-icon>
                    </button>
                    <button [attr.guide]="'common-file-upload-btn-6' + '__' + sanitizeUrl(url)" fxFlex.lt-md
                        color="warn" mat-raised-button type="button" (click)="uploader.clearQueue()"
                        [disabled]="!uploader.queue.length">Remove all</button>
                </div>
            </div>
        </div>

    </div>
</div>

<div fxLayout="column"
    *ngIf="type!='slider'  && type !='gmail' && type !='commonSlider' && type !='partnerLogo' && type !='formImage' && type != 'gallery' && type !='image' && type !='stepGuideImage'"
    fxLayoutGap="8px">

    <input [attr.guide]="'common-file-upload-inp-7' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" type="file"
        #myInput hidden ng2FileSelect [uploader]="uploader" [multiple]="multiple !== false" />
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" style="min-width: 0; max-width: 100%; overflow: hidden;">
        <button style="flex-shrink: 0;" [attr.guide]="'common-file-upload-choose-7' + '__' + sanitizeUrl(url)" type="button" mat-raised-button
            (click)="myInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            <span>Choose File</span>
        </button>
        <span class="chosen-file" fxFlex [title]="uploader?.queue?.length ? uploader.queue[0]?.file?.name : ''">
            {{ uploader?.queue?.length ? (uploader.queue[0]?.file?.name | slice:0:60) : 'No file chosen' }}
        </span>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" style="min-width: 0; max-width: 100%;">
        <button [attr.guide]="'common-file-upload-btn-8' + '__' + sanitizeUrl(url)"
            [disabled]="!uploader?.queue?.length || text !='Upload all'" (click)="upload()" type="button"
            mat-raised-button color="primary">
            <mat-icon>cloud_upload</mat-icon>
            <span>{{text}}</span>
            <mat-icon *ngIf="text !='Upload all'">
                <mat-spinner color="primary" diameter="20"></mat-spinner>
            </mat-icon>
        </button>
        <ng-content></ng-content>
    </div>

</div>

<div *ngIf="type=='gmail'" class="gmail-attach" fxLayoutAlign="start center">
    <button [attr.guide]="'common-file-upload-btn-attach-files' + '__' + sanitizeUrl(url)" mat-icon-button
        class="gmail-attach-btn" aria-label="Attach files" type="button" (click)="file.click()">
        <mat-icon>attach_file</mat-icon>
        <span class="gmail-attach-text">Attach files</span>
    </button>

    <input [attr.guide]="'common-file-upload-inp-files' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" hidden #file
        type="file" name="files" ng2FileSelect [uploader]="uploader" multiple (change)="upload()" />

    <div class="gmail-attachments" *ngIf="uploader?.queue?.length">
        <div class="gmail-chip" *ngFor="let row of uploader.queue; let i = index">
            <div class="file-icon">
                <mat-icon
                    *ngIf="!(row?.file?.name?.toLowerCase()?.endsWith('.png') || row?.file?.name?.toLowerCase()?.endsWith('.jpg') || row?.file?.name?.toLowerCase()?.endsWith('.jpeg') )">insert_drive_file</mat-icon>
                <mat-icon
                    *ngIf="row?.file?.name?.toLowerCase()?.endsWith('.png') || row?.file?.name?.toLowerCase()?.endsWith('.jpg') || row?.file?.name?.toLowerCase()?.endsWith('.jpeg')">image</mat-icon>
            </div>
            <div class="file-name" [title]="row?.file?.name">{{ row?.file?.name }}</div>
            <div class="file-actions">
                <mat-progress-bar *ngIf="row.isUploading" mode="indeterminate" class="mini-progress"></mat-progress-bar>
                <button [attr.guide]="'common-file-upload-btn-remove-attachment' + '__' + sanitizeUrl(url)"
                    mat-icon-button color="warn" (click)="row.remove()" aria-label="Remove attachment">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>